/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import { createSearchParams, Link as NavigationLink, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

// Component imports
import { Col, Descriptions, Typography } from 'antd';

// Misc imports
import { LIVECHAT_EVENT_TYPES, LIVECHAT_SCREEN_TABS } from '../../../constants/liveChat';
import { INTEGRATION_TYPE } from '../../../constants/integrations';
import { NAV_LIVECHAT } from '../../../constants/navigation';
import replaceUrlParams from '../../../utils/string/replaceUrlParams';
import { useTranslation } from 'react-i18next';
import { useFetchBotQuery } from '../../../store/bots/botsApi';

const { Text } = Typography;

const SessionLiveChatTab = ({ chatSession }) => {

  const { t } = useTranslation();
  const { orgId } = useParams();
  const tenantId = chatSession?.tenant?.id;
  const { data: bot } = useFetchBotQuery({ orgId, tenantId }, { skip: !tenantId });
  const isHelviaLivechat = !!bot?.plugins?.find(plugin => plugin.integration?.type === INTEGRATION_TYPE.HELVIA_LIVECHAT);

  return (
    <div className="overflow-y-auto pl-2 pr-2 overflow-x-hidden" style={{ maxHeight: 590 }}>
      <Col className="mb-3">
        <Text className={'fw-bold fs-lg'}>{t('LiveChat')}</Text>
      </Col>
      {isHelviaLivechat && (
        <Text className="pt-2 pb-2 text-primary">
          <NavigationLink to={`${replaceUrlParams(NAV_LIVECHAT, { orgId })}?${createSearchParams({
            tab: chatSession.liveChats[0]?.liveChatEventType === LIVECHAT_EVENT_TYPES.LIVECHAT_IS_IN_PROGRESS ? LIVECHAT_SCREEN_TABS.OPEN : LIVECHAT_SCREEN_TABS.CLOSED,
            conversation: chatSession.liveChats[0]?.conversationId
          }).toString()}`}>
            {t('View Conversation')}
          </NavigationLink>
        </Text>
      )}
      <Descriptions
        column={1}
        className={'mt-2'}
        labelStyle={{ fontWeight: 500, backgroundColor: 'inherit' }}
        contentStyle={{ backgroundColor: 'inherit' }}
      >
        <Descriptions.Item label={t('Conv. Participants')}>
          {
            chatSession.liveChats[0]?.agents?.length > 0
              ? chatSession.liveChats[0].agents.map(agent => agent).join(', ')
              : <Text className="text-secondary">{t('(Not available)')}</Text>
          }
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

SessionLiveChatTab.propTypes = {
  chatSession: PropTypes.array
};

export default SessionLiveChatTab;
